import React from 'react'
import { withStyles } from '@mui/styles';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';

import TableRow from '@mui/material/TableRow';

import Paper from '@mui/material/Paper';


const styles = theme => ({
    root: {
        width: '100%',
        backgroundColor: 'white',
        marginLeft: 10,
        marginRight: 10,
        marginTop: 10,
    },
    selected: {
        backgroundColor: '#90EEA4',
      },
    paper: {
 
    },
    spacerRow: {
        height: 2,
        borderLeft: 0,
        borderRight: 0,
        border: 0,
    },
    table: {
        lineHeight: 0.5,
        marginLeft: '5px',
        marginRight: '5px'
    },
    container2_table: {
        width: '100%',
        alignItems: 'center',
        paddingLeft: '1px',
        paddingRight: '1px',
        borderWidth: 0,
        boxShadow: 'none',
 
    },
    tabletop: {
        lineHeight: 0.5,
    },
    table2: {
        height: 500,
        border: '0px solid white'
    },
    bigfont: {
        fontSize: '24px',
        fontWeight: 'bold'
    },
    yrheadersaving: {
        backgroundColor: '#ff3099',
        color: 'white', 
        fontWeight: '900',
        textAlign: 'center',
        fontSize: '16px',
        borderLeft: '1px solid black',
        borderRight: '1px solid black'

    },
    headerwkwph: {
        width: 100,
    },
    headermoney: {
        width: 100,
    },
    totalRows: {
        fontWeight: 800,
        color: 'black',
    },
    yr1headers: {
 
    },
    borderRow: {
        border: '2px solid #326cd8',
    },
    header30: {
        backgroundColor: '#04c659',
        color: 'white',  
    },
    style30years: {
        fontSize: 14,
        fontWeight: 800,
        textDecoration: 'underline',
        paddingTop: 10,
        paddingBottom: 10,
        border: 0,
    },
    savingsHeaders: {
        backgroundColor: '#04c659',
        color: 'white',
        width: 100,
        fontWeight: 800,
        paddingTop: 2,
        paddingBottom: 2,
    },
    input: {
        fontSize: 12,
        paddingLeft: 5,
    },
    text30: {
        fontSize: 14,
        paddingTop: 2,
        paddingBottom: 2,

    },
    text30_beakeven: {
        fontSize: 14,
        paddingTop: 2,
        paddingBottom: 2,
        backgroundColor: '#90EEA4',

    },
    text_small: {
        fontSize: 12,
        paddingTop: 3,
        paddingBottom: 3,
    },
    yr1pt1: {
      color: '#326cd8',
      fontSize: 16,
      fontWeight: 600,
      textAlign: 'center'
    },
    yr1pt2: {
      color: '#ff3099',
      fontSize: '28px',
      fontWeight: 'bold',
      textAlign: 'center'
    },
    yr1pt3: {
      color: '#326cd8',
      fontSize: 16,
      fontWeight: 600,
      textAlign: 'center'
    },
    mediumFont: {
      color: '#326cd8',
      fontSize: '22px',
      fontWeight: 900,
      textAlign: 'center'
        
    },
    topRows: {
        paddingTop: 2,
        paddingBottom: 2,
        fontWeight: 'bold',
        textAlign: 'center',
        fontSize: '16px'
    },
    financeOptions: {
        fontSize: 12,
        width: 240,
    },
    lblFinanceOptions: {
        width: 240,
    },
    SelectItems: {
        fontSize: 12,
    },
    costinput: {
        paddingBottom: 0,
        fontSize: 12,
    },
    margin: {
        margin: theme.spacing(1),
        paddingBottom: 0,
    },
    financeTerm: {
        margin: theme.spacing(1),
        paddingBottom: 0,
        width: 120,    
        fontSize: 12
    },
    maintenanceOption: {
        margin: theme.spacing(1),
        paddingBottom: 0,
        width: 200,    
        fontSize: 12
        
    },
    wosButton: {
        borderWidth: 1,
        backgroundColor: '#ffffff',
        fontSize: 12,
        paddingTop: 5,
        paddingBottom:5
    
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
});

const CalcResultsSummaryTables = (props) => {
    const { classes, state } = props;

    return (
        <TableContainer component={Paper} className={classes.container2_table}  >
        <Table size="small" aria-label="a dense table" >
            <TableBody >
                <TableRow size="small" >
                    <TableCell colSpan={4} className={classes.topRows} >Your Year 1 Projected Savings</TableCell>
                </TableRow>

                <TableRow size="small" >
                    <TableCell className={classes.yrheadersaving}><br/><div className={classes.bigfont} >£ {state.yr1_batteryandsolar_benefit}</div>Solar + Battery Benefit<br/>&nbsp;</TableCell>
                    <TableCell className={classes.yrheadersaving}><br/><div className={classes.bigfont} >£ {state.yr1_smartproduct_benefit}</div>Smart Products Benefit</TableCell>
                    <TableCell className={classes.yrheadersaving}><br/><div className={classes.bigfont} >£ {state.yr1_smartexport_benefit}</div>Smart Export Benefit</TableCell>
                    {1==2 && <TableCell className={classes.yrheadersaving}><br/><div className={classes.bigfont} >£ {state.yr1_smarttariff_benefit}</div>Smart Tariff Benefit</TableCell>}
                </TableRow>
                <TableRow><TableCell className={classes.spacerRow}  colSpan={4} /></TableRow>
                <TableRow size="small" className={classes.borderRow} >
                    <TableCell ><div className={classes.yr1pt1}>Your Year 1 Financial benefit</div></TableCell>
                    <TableCell colSpan={2} ><div className={classes.yr1pt2}>£ {state.yr1_total}</div></TableCell>
                    <TableCell ><div className={classes.yr1pt3}>Saving {state.yr1_elec_savings}% of electricity bill<br/>Saving {state.yr1_gas_savings}% off your gas bill</div></TableCell>
                </TableRow>
                <TableRow size="small"><TableCell colSpan={4} className={classes.spacerRow} /></TableRow>

                <TableRow size="small" >
                    <TableCell colSpan={4} className={classes.topRows} >Your Average {state.calcterm} Year Projected Savings</TableCell>
                </TableRow>

                <TableRow size="small"  >
                    <TableCell className={classes.yrheadersaving}><br/><div className={classes.bigfont} >£ {state.avg_batteryandsolar_benefit}</div>Solar + Battery Benefit<br/>&nbsp;</TableCell>
                    <TableCell className={classes.yrheadersaving}><br/><div className={classes.bigfont} >£ {state.avg_smartproduct_benefit}</div>Smart Products Benefit</TableCell>
                    <TableCell className={classes.yrheadersaving}><br/><div className={classes.bigfont} >£ {state.avg_smartexport_benefit}</div>Smart Export Benefit</TableCell>
                    {1 ==2 && <TableCell className={classes.yrheadersaving}><br/><div className={classes.bigfont} >£ {state.avg_smarttariff_benefit}</div>Smart Tariff Benefit</TableCell>}
                </TableRow>
                <TableRow><TableCell className={classes.spacerRow}  colSpan={4} /></TableRow>
                <TableRow size="small" className={classes.borderRow} >
                    <TableCell ><div className={classes.yr1pt1}>Annual Average Financial Benefit</div></TableCell>
                    <TableCell colSpan={2} ><div className={classes.yr1pt2}>£ {state.avg_total}</div></TableCell>
                    <TableCell ><div className={classes.yr1pt3}>Average Annual ROI <span className={classes.mediumFont} >{state.avg_anual_roi}%</span></div></TableCell>
                </TableRow>
            </TableBody>
        </Table>
    </TableContainer>
    )
}


export default withStyles(styles, { withTheme: true })(CalcResultsSummaryTables)